import { render } from "./ViewPost.vue?vue&type=template&id=6246302f"
import script from "./ViewPost.vue?vue&type=script&lang=js"
export * from "./ViewPost.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Devs\\Fullstack\\NewDeal\\vue_app_api\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__